import React from 'react';
import ModalitiesSection from './ModalitiesOccupationalSection';

function TherapeuticListening() {
  const servicesData = [
    {
      name: 'What is it?',
      description:
        'Therapeutic listening is a sound-based intervention that calms the nervous system through precise and uniquely-controlled sensory input. Electronic modifications, along with the organized, rhythmical sound patterns inherent in music, trigger the self-organizing capacities of the nervous system.',
    },
    {
      name: 'Who can benefit from it?',
      description: 'Therapeutic listening can help those who exhibit:',
      items: [
        'Poor attention',
        'Challenges with play and peer interaction',
        'Verbal/non-verbal communication difficulties',
        'Sleep disturbances',
        'Abnormal sensory responses',
        'Mood disturbances and irritability',
        'Difficulties with motor planning and sequencing',
        '…And more!',
        'Difficulties with energy regulation',
      ],
    },
  ];

  return (
    <main className="bg-[#F0EFEF]">
      <div className="w-full flex flex-col gap-10 max-w-[1200px] mx-auto px-2 sm:px-4 md:px-10 py-4 sm:py-10 md:py-20 relative z-10">
        <ModalitiesSection services={servicesData} />
      </div>
    </main>
  );
}

export default TherapeuticListening;
